import { render } from "./AppSubHeaderStoreOutputCreate.vue?vue&type=template&id=196954a6"
import script from "./AppSubHeaderStoreOutputCreate.vue?vue&type=script&lang=js"
export * from "./AppSubHeaderStoreOutputCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__